import { render, staticRenderFns } from "./usestatistics.vue?vue&type=template&id=666dd540&scoped=true&"
import script from "./usestatistics.vue?vue&type=script&lang=js&"
export * from "./usestatistics.vue?vue&type=script&lang=js&"
import style0 from "./usestatistics.vue?vue&type=style&index=0&id=666dd540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666dd540",
  null
  
)

export default component.exports